// extracted by mini-css-extract-plugin
export var base = "roundedButton-module--base--RjUp1";
export var centered = "roundedButton-module--centered--xiG4k";
export var orange = "roundedButton-module--orange--T-ipX";
export var shadowStartOrange = "roundedButton-module--shadowStartOrange--pmV-i";
export var slideUp = "roundedButton-module--slideUp--TfHUD";
export var slideUpLarge = "roundedButton-module--slideUpLarge--gnUbh";